export default __webpack_public_path__ + "static/media/ic_clipboard.191602fe.svg";